export default function SvgGlobalDefs() {
  return (
    <svg style={{ position: 'absolute', top: '-1000px' }}>
      <linearGradient id="waveform-bg-raman" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0" style={{ stopColor: '#2ea3f8b0' }} />
        <stop offset="1" style={{ stopColor: '#2ea4f810' }} />
      </linearGradient>
      <linearGradient id="waveform-bg-rydberg" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0" style={{ stopColor: '#8a39f2b0' }} />
        <stop offset="1" style={{ stopColor: '#8a39f210' }} />
      </linearGradient>
      <linearGradient id="waveform-bg-microwave" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0" style={{ stopColor: '#ff986eb0' }} />
        <stop offset="1" style={{ stopColor: '#ff986e10' }} />
      </linearGradient>
    </svg>
  );
}
